import React, { useState, useEffect } from "react";
import { getConcernData } from "../service/api";

import { useNavigate } from 'react-router-dom'

import '../components/css/Dashboard-styles.css'
import { encryptStorage } from "../constant";



const ConcernData = () => {

    const [data, setData] = useState([]);

    const navigate = useNavigate()

    useEffect(() => {

        fetchApi()

    }, [])

    const fetchApi = async () => {
        let data = encryptStorage.getItem('role');

        const resp = await getConcernData(data)


        if (resp?.data?.ResponseData?.length > 0) {

            if (resp.data.ResponseData.length > 5) resp.data.ResponseData.length = 5

            setData(resp.data.ResponseData)
        }
    }

    const navigateTo = async (typeId, concernId) => {

        navigate('/concernview', { state: { concern: { type: typeId, concern_id: concernId } } })
    }


    const concernBody = () => {

        try {

            return (

                data.map((datum, i) => {

                    return (
                        <>
                            <div className="row mb-4">
                                <div className="d-flex">
                                    <div className="d-block mx-3">
                                        <img src="/Images/logo-person-user-person-icon.jpg" className="dashboard-concernpic-size-48" />
                                    </div>
                                    <div className="d-block">
                                        {datum.description.length <= 50 ?
                                            <p className="mb-0 dashboard-text-spacing"><a onClick={() => { navigateTo(datum.concern_type_id, datum.id) }} className="font-12 dashboard-link text-decoration-none semibold-text text-break" >{datum.description}</a></p> :
                                            <p className="mb-0 dashboard-text-spacing teammem-text-trunc pe-3"><a onClick={() => { navigateTo(datum.concern_type_id, datum.id) }} className="font-12 dashboard-link text-decoration-none semibold-text text-break" >{datum.description}</a></p>}
                                        <label className="font-12 medium-text dashboard-username-color dashboard-text-spacing">{datum.emp_name}</label>
                                    </div>
                                </div>
                            </div>
                        </>
                    )

                })


            )
        }
        catch (err) {


        }


    }

    return (

        <>
            {concernBody()}

            <div className="text-end">
                <a onClick={() => { navigate('/concerns?tab=teamconcern', { state: { way: 'Team Member' } }) }} className="semibold-text font-12 pe-3 text-decoration-none">View all<span><img src="/Images/view all.png" className="dashboard-view-arrow-size ms-1" /></span></a>
            </div>
        </>
    )

}

export default ConcernData